import buttons from "./buttons"
import styles from "./styles"

export default {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: "'Inter', sans-serif",
    heading: "'Inter', sans-serif",
    handwriting: "'Coming Soon', serif",
    monospace: "Menlo, monospace",
  },
  fontSizes: [
    "0.625rem",
    "0.75rem",
    "0.875rem",
    "1rem",
    "1.3125rem",
    "1.75rem",
    "2.375rem",
    "3.125rem",
    "4.5rem",
  ],
  fontWeights: {
    body: 400,
    heading: 600,
    medium: 500,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  colors: {
    text: "#454545",
    background: "#fff",
    primary: "#B92A2E",
    secondary: "#C97740",
    accent: "#C97740",
    highlight: "#B92A2E",
    dark: "#1F1E1C",
    light: "#AFB0B3",
    muted: "#E8CD4B",
  },
  breakpoints: ["40em", "56em", "85rem"],
  radii: {
    default: "1.25rem",
  },
  shadows: {
    default: "0 0.25rem 1.625rem rgba(0,0,0,0.3)",
  },
  sizes: {
    container: 1200,
  },
  styles,
  buttons,
}
